import React from "react";

import "./winnerProfile.css";

import AvatarFace from "../../assets/img/avatar-face.jpg";
import { useEffect } from "react";
import { getUserScoreProfile } from "../../services/MainApiDetails";
import { useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import constant from "../../utilities/constants.json";
import UserFace from "../../assets/img/avatar-face.jpg";
import Moment from "moment";
import { useSettings } from "../../hooks/useSettings";
import { formatLabel } from "../../utilities/string";
let img_url = constant.profile_image;

let team_url = constant.team_image;

const WinnerProfile = () => {
  const [userScoreProfile, setUserScoreProfile] = useState();
  const navigate = useNavigate()
  const settings = useSettings()
  const matchDays = settings?.match_dates

  const location = useLocation();
  // console.log(location);

  // console.log(location.state.user_id);

  let userId = location.state.user_id;

  let userRank = location.state.rank;

  let userTeam = userScoreProfile?.user_data.team;

  useEffect(() => {
    getUserprofile();
  }, []);
  useEffect(() => {
    dailyScoreDetails();
  }, [userScoreProfile]);
  function getUserprofile() {
    getUserScoreProfile({ user_id: userId })
      .then((res) => {
        if (res.data.status == 1) {
          setUserScoreProfile(res.data.message);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }



  function dailyScoreDetails() {
    let dailyData = userScoreProfile?.daily_profile;

    let questionData = userScoreProfile?.question_count;
    return questionData?.map((item, index) => {

      let dailyDetails = dailyData.find((val) => val.group_label == item.group_label);
      let totalScoreDetails = item;
      const day = formatLabel(item?.group_label)


    const startDate = Moment(item?.start_date, "DD/MM/YYYY/MM/DD");
    const endDate = Moment(item?.end_date, "DD/MM/YYYY");
    const dateDisplay = startDate.toLocaleString() === endDate.toLocaleString() ?startDate.format("DD MMM") :`${startDate.format("DD MMM")} - ${endDate.format("DD MMM")}`;

      return (
        <div key={`${item?.group_label}${userScoreProfile?.user_data?._id}`} className="winnerProfile-matchStat-box">
          <div className="winnerProfile-matchStat-pointWrapper">
            <div className="winnerProfile-matchStat-point-wrapper">
              <h4>{dailyDetails ? dailyDetails.score : 0}</h4>
              <h6>Pts</h6>
            </div>
            <div className="winnerProfile-matchDay-totalPoint">

              <p>{totalScoreDetails.total_score} Pts</p>
            </div>
          </div>

          <div className="winnerProfile-matchStat-boxWrapper">
            <div key={index} className="winnerProfile-matchStat-box-top">
              <div className="winnerProfile-matchStat-prediction-wrapper">
                <div className="right-wrapper">
                  <h6>
                    {dailyDetails && dailyDetails.total_win
                      ? dailyDetails.total_win
                      : 0}
                  </h6>
                  <div className="right-text">
                    <p>Right</p>
                    <p>Predictions</p>
                  </div>
                </div>
                <div className="wrong-wrapper">
                  <h6>
                    {dailyDetails && dailyDetails.total_lose
                      ? dailyDetails.total_lose
                      : 0}
                  </h6>
                  <div className="right-text">
                    <p>Wrong</p>
                    <p>Predictions</p>
                  </div>
                </div>
                <div className="missed-wrapper">
                  <h6>
                    {dailyDetails
                      ? parseInt(item.count) -
                        parseInt(dailyDetails.total_attented)
                      : parseInt(item.count)}
                  </h6>
                  <div className="right-text">
                    <p>Missed</p>
                    <p>Predictions</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="winnerProfile-matchStat-box-bottom">
              <div className="winnerProfile-matchStat-box-matchDate-wrapper">
                <p>
                  {/*Match Day {parseInt(questionData.length) - parseInt(index)}*/}
                  {day}
                </p>
                <p>{dateDisplay}</p>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }

  return (
    <div className="winnerProfile">
       <div className="winnerProfile-top-goback">
            <div className="winnerProfile-backButton" onClick={()=>navigate(-1)}>
             <div className="arrow">
                <ArrowBackIosIcon className="icon" />
              </div>
              <p>User Profile</p>
            </div>
          </div>
      <div className="winnerProfile-box-wrapper">
        
        <div className="winnerProfile-box">
          <div className="winnerProfile-img-wrapper">
            <img
              src={
                userScoreProfile?.user_data
                  ? img_url + userScoreProfile.user_data?.image
                  : AvatarFace
              }
              alt=""
              onError={(e) =>
                (e.target.onerror = null)((e.target.src = UserFace))
              }
            />
          </div>
          <div className="winnerProfile-info-wrapper">
            <p className="winnerProfile-info-name">
              {userScoreProfile?.user_data.name}
            </p>
            <p className="winnerProfile-info-points">
              {userScoreProfile?.total_score} Pts
            </p>
            {userTeam ? (
              <div className="winnerProfile-info-fav-team">
                <div className="fav-team">
                  <img src={team_url + userTeam.team_flag} alt="" />
                </div>
                <p>{userTeam.team_name}</p>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className={userRank ? "winnerProfile-rank-wrapper":"winnerProfile-no-rank-wrapper"}>
          {!!userRank &&
          <>
          <h2>{userRank}</h2>
            <h6>Rank</h6>
          </>
          }
          </div>
        </div>
      </div>

      {/* <div className="winnerProfile-matchStat-box-wrapper"> */}
      <div className="winnerProfile-matchStat-box-wrapper">
        {dailyScoreDetails()}
      </div>

    </div>
  );
};

export default WinnerProfile;
